module.exports = __webpack_public_path__ + "img/Empty-state.ec4c066e.svg";